export enum ColorScheme {
  Green = "#00ff00",
  Red = "#ff0000",
}

export enum Mode {
  ffe = "ffe", // First Floor Elevation
  real = "real",
  model_2 = "2",
  model_5 = "5",
  model_10 = "10",
  model_20 = "20",
  model_50 = "50",
  model_100 = "100",
  model_500 = "500",
  model_1500 = "1500",
}

export enum Season {
  Spring = "Spring",
  Summer = "Summer",
  Autumn = "Autumn",
  Winter = "Winter",
}

// Interfaces
export interface FormState {
  mode: Mode;
}

// total_co2_kg_m2_yr_1_Autumn

import { Dispatch, SetStateAction } from "react";
import { LngLatBoundsLike } from "react-map-gl/maplibre";

export type DemoStep = number;

export type SetDemoStep = Dispatch<SetStateAction<DemoStep>>;

export type Description = {
  paragraph_one?: string;
  paragraph_two?: string;
};
export type DataStep = {
  title?: string;
  description?: Description;
  copy?: string | React.ReactNode;
  showExploreButton?: boolean;
  showSpeakToExpertButton?: boolean;
};

export type Coordinates = {
  latitude: number;
  longitude: number;
};

interface GeocoderAttributes {
  [key: string]: string;
}

export interface SelectAddressArgs {
  longitude: number;
  latitude: number;
  geocoder_attributes: GeocoderAttributes;
  zoomLevel: number;
  targetStep?: number;
}
export interface StepComponentProps {
  moveToNextLocation: (args: SelectAddressArgs) => void;
  nextStep: () => void;
  backStep: () => void;
  goToStep: (stepNumber: number) => void;
  data: DataStep;
  coordinates: Coordinates;
  previousCoordinates: Coordinates;
  nextCoordinates: Coordinates;
  zoomLevel: number;
  previousZoomLevel: number;
  attributes: Attributes;
  id: number;
  selectedLayer: string | null;

  handleMarker: () => void;
  formState?: FormState;
  layer_name?: string;
}

export interface Attributes {
  geometry: Object;
  properties: Record<string, any>;
  layer: any;
  source: string;
}

export type MapConfig = {
  zoomLevel: number;
  minZoom?: number;
  compare?: boolean;
  boundingBox?: LngLatBoundsLike;
  bearing?: number;
  pitch?: number;
};

export interface GeoJsonDemoMapLayer {
  layerName: string;
  geojsonPath: string;
  createStyle: (formState: FormState, selectedId: string | null) => object;
  beforeId?: string;
}

export type StepDemoConfig = {
  id: number;
  propertyDetails?: boolean;
  component: React.FC<StepComponentProps>;
  mapConfig: MapConfig;
  data: DataStep;
  layer: object;
  coordinates: Coordinates;
  geojsonLayers?: GeoJsonDemoMapLayer[];
};
